import { graphql } from '@/gql';
import type { FetchPartnersQuery, FetchPartnersQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export type FetchPartnersInput = FetchPartnersQueryVariables;

export type FetchPartnersOutput = FetchPartnersQuery['partners'];

export const fetchPartners = async ({
  isDisabled,
  search,
  pagination,
  codeName,
  orderBy,
  sortType,
}: FetchPartnersInput): Promise<FetchPartnersOutput> => {
  const response = await queryExecute({
    query: graphql(`
      query FetchPartners(
        $isDisabled: Boolean
        $search: String
        $codeName: String
        $orderBy: String
        $sortType: String
        $pagination: PaginationInputType
      ) {
        partners(
          isDisabled: $isDisabled
          search: $search
          codeName: $codeName
          orderBy: $orderBy
          sortType: $sortType
          pagination: $pagination
        ) {
          count
          rows {
            id
            name
            codeName
            callCenterNumber
            gogoNumber
            extension
            phoneNumber
            email
            streetAddress
            streetAddress2
            city
            state
            country
            zip
            latitude
            longitude
            timeZone
            website
            stripeCustomerId
            subsidyType
            subsidyAmt
            membersFlatFee
            maxSubsidyAmt
            credits
            creditsAmtMin
            creditsRenewedAt
            creditsRenewNum
            creditsRenewNumType
            maxRides
            maxRidesRenewedAt
            maxRidesRenewNum
            maxRidesRenewNumType
            subsidyCondition
            rideType
            description
            infoForDriver
            infoForOperator
            contactFirstName
            contactLastName
            contactPhoneNumber
            contactEmail
            websiteRegistration
            websiteDashboard
            numberOfRides
            notes
            isDisabled
            isAutoConfirmSurge
            ridePaymentTier
            specialRequestTier
            pharmacyPaymentTier
            gourmetPaymentTier
            groceryPaymentTier
            operatorOrderedRidePrice
            subsidyDescription
            subsidyLocations
            isIncludeInMoveUserIntoPartnershipForm
            isHideRegistrationLink
            isSendRenewalNotification
            turnOnRideOrderingLPAlert
            isRecordAllCalls
            isRollsOverMaxRides
            partnerHours {
              day
              partnerId
              start
              end
            }
            scheduledRideConfirmedEmail
            scheduledRideReminderDayBeforeEmail
            isSendWelcomeKits
            isShowUserPersonalRidesOnPartnerDashboard
            isAutoTip
            tipType
            tipAmount
            tipMinAmount
            tipMaxAmount
            membershipType
            membershipAmount
            maxCallers
            plan
            transactionalSms
            noMail
            marketingMail
            isAlwaysOperator
            abTestOptions
            noCrm
            allowCallersVoipPhoneNumbers
            welcomeMessageUrl
            logoUrl
            collectCc
            transactionalMail
            marketingEmails
            transactionalEmails
            transactionalEmails
            marketingRobocalls
            transactionalRobocalls
            noRobocalls
            marketingSms
            transactionalSms
            rideAllowance {
              tiers {
                name
                allowance
              }
            }
            newSubsidy
            serviceCode
          }
        }
      }
    `),
    variables: {
      isDisabled,
      search,
      codeName,
      orderBy,
      sortType,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.partners;
};
